import React, { useLayoutEffect, useState, useContext } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { AuthContext } from "../Context/AppContext";

const NavBar = ({ children }) => {
  const { userInfo, setUserInfo, handleShowModalUserSettings } = useContext(AuthContext);
  const [moveSidebar, setMoveSidebar] = useState(false);
  const navigate = useNavigate();
  const location = useLocation(); // Hook to get the current route

  const handlerLogOut = () => {
    localStorage.removeItem("token-api");
    setUserInfo({
      firstName: "",
      lastName: "",
    });
    navigate(`/`);
  };

  // Immediately apply sidebar class change
  useLayoutEffect(() => {
    const sidebar = document.getElementById("sidebar");
    if (sidebar) {
      sidebar.classList.toggle("collapsed", moveSidebar);
    }
  }, [moveSidebar]);

  return (
    <div className="wrapper">
      <nav id="sidebar" className={!moveSidebar ? "sidebar" : "sidebar collapsed"}>
        <div className="sidebar-content js-simplebar">
          <ul className="sidebar-nav">
            <li className="sidebar-header">{/* Nightspot */}</li>
            <li className="sidebar-item active">
              <ul id="dashboards" className="list-unstyled collapse show" data-bs-parent="#sidebar">
                <a href="/my/dashboard">
                  <img src="/img/logo/logo.svg" alt="Logo" className="sidebar-brand" />
                </a>
                <li className={`sidebar-item ${location.pathname === "/my/admin/dashboard" ? "active" : ""}`}>
                  <Link className="sidebar-link" to="/my/admin/dashboard">
                    <i className="fa-solid fa-house"></i> Dashboard
                  </Link>
                </li>
                <li className={`sidebar-item ${location.pathname === "/my/admin/venues-approval" ? "active" : ""}`}>
                  <Link className="sidebar-link" to="/my/admin/venues-approval">
                    <i className="fa-solid fa-location-dot ms-1"></i> Venues to aprove
                  </Link>
                </li>
                <li className={`sidebar-item ${location.pathname === "/my/admin/venues" ? "active" : ""}`}>
                  <Link className="sidebar-link" to="/my/admin/venues">
                    <i className="fa-solid fa-location-dot ms-1"></i> Venues List
                  </Link>
                </li>
                <li className={`sidebar-item ${location.pathname === "/my/admin/events" ? "active" : ""}`}>
                  <Link className="sidebar-link" to="/my/admin/events">
                    <i className="fa-solid fa-calendar ms-1"></i> Events List
                  </Link>
                </li>
                <li className={`sidebar-item ${location.pathname === "/my/admin/stories-generator" ? "active" : ""}`}>
                  <Link className="sidebar-link" to="/my/admin/stories-generator">
                    <i className="fa-solid fa-image ms-1"></i> Stories Generator
                  </Link>
                </li>
                <li className={`sidebar-item ${location.pathname === "/my/admin/users" ? "active" : ""}`}>
                  <Link className="sidebar-link" to="/my/admin/users">
                    <i className="fa-solid fa-users me-2"></i> Users
                  </Link>
                </li>
                <li className={`sidebar-item ${location.pathname === "/my/admin/payments" ? "active" : ""}`}>
                  <Link className="sidebar-link" to="/my/admin/payments">
                    <i className="fa-solid fa-cart-shopping me-2"></i> Subscrições
                  </Link>
                </li>
                <li className={`sidebar-item ${location.pathname === "/my/admin/withdrawal-request" ? "active" : ""}`}>
                  <Link className="sidebar-link" to="/my/admin/withdrawal-request">
                    <i className="fa-solid fa-cart-shopping me-2"></i> Pedidos Levantamentos
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
      <div className="main">
        <nav className="navbar navbar-expand navbar-bg">
          <a className="sidebar-toggle" onClick={() => setMoveSidebar(!moveSidebar)}>
            <i className="hamburger align-self-center"></i>
          </a>
          <div className="navbar-collapse collapse">
            <ul className="navbar-nav navbar-align">
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle d-none d-sm-inline-block" href="#" data-bs-toggle="dropdown">
                  <span>{userInfo.firstName} {userInfo.lastName}</span>
                </a>
                <div className="dropdown-menu dropdown-menu-end">
                  <a className="dropdown-item" onClick={handleShowModalUserSettings}>
                    <i className="align-middle me-1" data-lucide="user"></i> Perfil
                  </a>
                  <div className="dropdown-divider"></div>
                  <a className="dropdown-item" onClick={handlerLogOut}>Sair</a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <main className="content">{children}</main>
      </div>
    </div>
  );
};

export default NavBar;
